import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-wu-alert',
    templateUrl: './wu-alert.component.html',
    standalone: false
})
export class WuAlertComponent {
  @Input() message: string;
}
